// Axios
import gql from 'graphql-tag'

export const GET_VEHICLE_STATUSES = gql`
  query VehicleStatuses($filter: GetVehicleStatusesInput) {
    vehicleStatuses(filter: $filter) {
      message
      isSuccessful
      vehicleStatuses {
        vehicleId
        longitude
        licensePlate
        latitude
        temperature
        speed
        calculatedSpeed
        engineOn
        direction
        vehicle {
          status
          hullNo
          imei
          driverShift {
            driverId
            driver {
              phoneNo
              fullname
              rfids {
                rfid
              }
            }
          }
          driver1 {
            phoneNo
            fullname
          }
          vehicleType {
            category
            type
            model
            icon
          }
          device {
            identifier
            phoneNo
            deviceName
          }
        }
        lastPacket
        lastReceive
        sumDistance
        sumDrivetime
        fuelFiltered
        fuelCapacity
        motionStatus
        calculatedMotionStatus
        signalStrength
        tripstartOn
        tripDistance
        tripDrivetime
        timeInStatus
        sumDrivetimeFormatted
        door1Status
        door2Status
        refrigeratorStatus
        ptoStatus
        controlTowerData {
          status
          alerts {
            alert {
              descriptionEng
              descriptionIdn
              iconUrl
            }
            alertCode
            alertData
          }
          viewedOn
        }
        vendorName
        workhour
        workhourFormatted
        lastPositionStatus
      }
    }
  }
`

export const GET_VEHICLE_STATUSES_LIVETRACK = gql`
  query VehicleStatuses($filter: GetVehicleStatusesInput) {
    vehicleStatuses(filter: $filter) {
      message
      isSuccessful
      vehicleStatuses {
        vehicleId
        longitude
        licensePlate
        latitude
        temperature
        speed
        calculatedSpeed
        engineOn
        direction
        vehicle {
          status
          hullNo
          imei
          vehicleType {
            category
            type
            model
            icon
          }
          device {
            identifier
            phoneNo
            deviceName
          }
        }
        lastPacket
        lastReceive
        sumDistance
        sumDrivetime
        fuelFiltered
        fuelCapacity
        motionStatus
        calculatedMotionStatus
        signalStrength
        tripstartOn
        tripDistance
        tripDrivetime
        timeInStatus
        sumDrivetimeFormatted
        door1Status
        door2Status
        refrigeratorStatus
        ptoStatus
        controlTowerData {
          status
          alerts {
            alert {
              descriptionEng
              descriptionIdn
            }
            alertCode
            alertData
          }
          viewedOn
        }
        vendorName
        workhour
        workhourFormatted
        lastPositionStatus
      }
    }
  }
`

export const GET_VEHICLE_STATUSES_FOR_DASHBOARD_CARD = gql`
  query VehicleStatuses($filter: GetVehicleStatusesInput) {
    vehicleStatuses(filter: $filter) {
      message
      isSuccessful
      vehicleStatuses {
        vehicleId
        longitude
        licensePlate
        latitude
        vehicle {
          status
          hullNo
          imei
          driver1 {
            phoneNo
            fullname
          }
          vehicleType {
            category
            type
            model
            icon
          }
          device {
            identifier
            phoneNo
            deviceName
          }
        }
        motionStatus
        calculatedMotionStatus
      }
    }
  }
`

export const GET_VEHICLE_STATUSES_CONTROL_TOWER = gql`
  query VehicleStatuses($filter: GetVehicleStatusesInput) {
    vehicleStatuses(filter: $filter) {
      message
      isSuccessful
      vehicleStatuses {
        vehicleId
        longitude
        licensePlate
        latitude
        temperature
        speed
        calculatedSpeed
        engineOn
        direction
        lastPacket
        lastReceive
        sumDistance
        sumDrivetime
        fuelFiltered
        fuelCapacity
        motionStatus
        calculatedMotionStatus
        signalStrength
        tripstartOn
        tripDistance
        tripDrivetime
        timeInStatus
        sumDrivetimeFormatted
        door1Status
        door2Status
        refrigeratorStatus
        ptoStatus
        vehicleGroups
        vehicle {
          status
          hullNo
          imei
          driver1 {
            phoneNo
            fullname
          }
          vehicleType {
            category
            type
            model
            icon
          }
          device {
            identifier
            phoneNo
            deviceName
          }
        }
        controlTowerData {
          status
          alerts {
            createdOn
            vehicleId
            alertCode
            driverId
            alertFlag
            alertData
            latitude
            longitude
            alertTrigger
            threshold
            alert {
              descriptionEng
              descriptionIdn
              fullDescriptionEng
              fullDescriptionIdn
              iconUrl
            }
          }
          viewedOn
        }
        lastPositionStatus
        accuVoltage
        sumFuel
        fuel
      }
    }
  }
`

export const GET_VEHICLE_STATUSES_CONTROL_TOWER_V2 = gql`
  query VehicleStatusesRevamped($filter: GetVehicleStatusesInput) {
    vehicleStatusesRevamped(filter: $filter) {
      message
      isSuccessful
      vehicleStatusesRevamped {
        vehicleId
        longitude
        licensePlate
        latitude
        temperature
        speed
        calculatedSpeed
        engineOn
        direction
        lastPacket
        lastReceive
        sumDistance
        sumDrivetime
        fuelFiltered
        fuelCapacity
        motionStatus
        calculatedMotionStatus
        signalStrength
        tripstartOn
        tripDistance
        tripDrivetime
        timeInStatus
        sumDrivetimeFormatted
        door1Status
        door2Status
        refrigeratorStatus
        ptoStatus
        vehicleGroups
        vehicle {
          status
          hullNo
          imei
          driver1 {
            phoneNo
            fullname
          }
          vehicleType {
            category
            type
            model
            manufacturer
            icon
          }
          device {
            identifier
            phoneNo
            deviceName
            deviceCode
          }
          sensor {
            sensorType {
              sensorCode
              sensorName
            }
          }
        }
        lastPositionStatus
        accuVoltage
        sumFuel
        fuel
        controlTowerData {
          totalAlerts
          totalResolvedAlerts
          totalUnresolvedAlerts
          totalShownAlerts
          totalOtherAlerts
          totalShownUnresolvedAlerts
          totalOtherUnresolvedAlerts
          pinned
          cols
          urgent {
            totalAlerts
            totalResolvedAlerts
            totalUnresolvedAlerts
            totalShownAlerts
            totalOtherAlerts
            totalShownUnresolvedAlerts
            totalOtherUnresolvedAlerts
            alerts {
              rawAlertId
              createdOn
              vehicleId
              alertCode
              alertFlag
              isResolved
              resolvedChangedAt
              resolvedChangedBy
              resolver
              alert {
                alertCategories {
                  alertCategoryId
                }
                descriptionEng
                descriptionIdn
                fullDescriptionEng
                fullDescriptionIdn
                iconUrl
              }
              isImportant
              isUrgent
            }
            unresolvedAlerts {
              rawAlertId
              createdOn
              vehicleId
              alertCode
              alertFlag
              isResolved
              resolvedChangedAt
              resolvedChangedBy
              resolver
              alert {
                alertCategories {
                  alertCategoryId
                }
                descriptionEng
                descriptionIdn
                fullDescriptionEng
                fullDescriptionIdn
                iconUrl
              }
              isImportant
              isUrgent
            }
          }
          important {
            totalAlerts
            totalResolvedAlerts
            totalUnresolvedAlerts
            totalShownAlerts
            totalOtherAlerts
            totalShownUnresolvedAlerts
            totalOtherUnresolvedAlerts
            alerts {
              rawAlertId
              createdOn
              vehicleId
              alertCode
              alertFlag
              isResolved
              resolvedChangedAt
              resolvedChangedBy
              resolver
              alert {
                alertCategories {
                  alertCategoryId
                }
                descriptionEng
                descriptionIdn
                fullDescriptionEng
                fullDescriptionIdn
                iconUrl
              }
              isImportant
              isUrgent
            }
            unresolvedAlerts {
              rawAlertId
              createdOn
              vehicleId
              alertCode
              alertFlag
              isResolved
              resolvedChangedAt
              resolvedChangedBy
              resolver
              alert {
                alertCategories {
                  alertCategoryId
                }
                descriptionEng
                descriptionIdn
                fullDescriptionEng
                fullDescriptionIdn
                iconUrl
              }
              isImportant
              isUrgent
            }
          }
        }
        children {
          vehicleId
          latitude
          longitude
          lastReceive
          calculatedSpeed
          calculatedMotionStatus
          engineOn
          lastPositionStatus
          signalStrength
          vehicle {
            device {
              deviceCode
            }
            imei
          }
        }
      }
    }
  }
`

export const GET_VEHICLE_STATUSES_TRACKVISION = gql`
  query VehicleStatuses($filter: GetVehicleStatusesInput) {
    vehicleStatuses(filter: $filter) {
      message
      isSuccessful
      vehicleStatuses {
        vehicleId
        longitude
        licensePlate
        latitude
        lastReceive
        calculatedMotionStatus
        engineOn
        vehicle {
          device {
            deviceCode
            phoneNo
          }
          imei
          vehicleType {
            type
            category
          }
        }
      }
    }
  }
`

export const GET_VEHICLE_STATUSES_PAGINATED = gql`
  query VehicleStatusesPaginated($filter: GetVehicleStatusesWithPaginationInput) {
    vehicleStatusesPaginated(filter: $filter) {
      isSuccessful
      errorCode
      errorName
      message
      status
      vehicleStatusesPaginated {
        data {
          vehicleId
          licensePlate
          vehicle {
            status
            hullNo
            imei
            driver1 {
              phoneNo
              fullname
            }
            vehicleType {
              category
              type
              model
              icon
            }
            device {
              identifier
              phoneNo
              deviceName
            }
          }
          controlTowerData {
            status
            alerts {
              alert {
                descriptionEng
                descriptionIdn
              }
              alertCode
              alertData
            }
            viewedOn
          }
        }
        pagination {
          total
          page
          show
        }
      }
    }
  }
`

export const GET_VEHICLE_STATUS = gql`
  query VehicleStatus($filter: GetVehicleStatusInput!) {
    vehicleStatus(filter: $filter) {
      isSuccessful
      errorCode
      errorName
      message
      status
      vehicleStatus {
        direction
        workhourFormatted
        longitude
        latitude
        vehicle {
          driverShift {
            driverId
            driver {
              phoneNo
              rfids {
                rfid
              }
            }
          }
          driver1 {
            phoneNo
            rfids {
              rfid
            }
          }
        }
        calculatedSpeed
        vehicleId
      }
    }
  }
`

export const GET_VEHICLE_STATUS_LIVETRACK = gql`
  query VehicleStatus($filter: GetVehicleStatusInput!) {
    vehicleStatus(filter: $filter) {
      isSuccessful
      errorCode
      errorName
      message
      status
      vehicleStatus {
        direction
        workhourFormatted
        longitude
        latitude
        calculatedSpeed
        vehicleId
        vehicle {
          vehicleType {
            icon
          }
        }
        calculatedMotionStatus
      }
    }
  }
`

export const GET_VEHICLE_IN_FENCE = gql`
  query VehiclesInFence($filter: VehiclesInFenceFilter) {
    vehiclesInFence(filter: $filter) {
      isSuccessful
      message
      vehiclesInFence {
        totalVehicle
        geofence {
          fenceName
          polyData
          circData
          type
          province
          city
          phoneNo
          contactName
        }
        totalGroup
        vgroup {
          id
          name
          vehicles {
            timeInGeofence
            vehicle {
              id
              driver1 {
                fullname
              }
              licensePlate
              hullNo
              imei
              vehicleType {
                category
                type
                icon
              }
            }
          }
        }
      }
    }
  }
`

export const GET_SUMMARY_TRIP = gql`
  query SummaryTrips($filter: SummaryTripsFilter!) {
    summaryTrips(filter: $filter) {
      isSuccessful
      message
      summaryTrips {
        summaryTrips {
          vehicleId
          tripMileage
          startLong
          startLat
          stopLong
          stopLat
          maxSpeed
          startTime
          stopTime
          totalHourStart
          totalHourStop
          type
          driver {
            fullname
          }
        }
        totalTrip
        totalHourStart
        totalHourStop
        totalAssistedTripDistance
        totalAssistedTripDuration
        totalMovingTripDistance
        totalMovingTripDuration
      }
    }
  }
`

export const GET_LAST_SUMMARY_TRIP = gql`
  query LastSummaryTrip($filter: LastSummaryTripsFilter!) {
    lastSummaryTrip(filter: $filter) {
      isSuccessful
      message
      lastSummaryTrips {
        summaryTrips {
          startTime
          stopTime
          vehicleId
          tripMileage
          startLong
          startLat
          stopLong
          stopLat
          maxSpeed
          totalHourStart
          totalHourStop
        }
        totalTrip
        totalHourStart
        totalHourStop
        motionStatus
      }
    }
  }
`

export const GET_RAW_LOCATION = gql`
  query RawLocations($filter: GetRawLocationsFilter!) {
    rawLocations(filter: $filter) {
      isSuccessful
      message
      rawLocations {
        sentOn
        latitude
        longitude
        vehicleId
        speed
        direction
      }
    }
  }
`

export const GET_RAW_ALERTS = gql`
  query RawAlerts($filter: GetRawAlertFilter) {
    rawAlerts(filter: $filter) {
      isSuccessful
      message
      rawAlerts {
        data {
          createdOn
          vehicleId
          alertFlag
          alertData
          formattedAlertData
          latitude
          longitude
          alertTrigger
          threshold
          cost
          driver {
            fullname
          }
          alert {
            alertCode
            descriptionEng
            descriptionIdn
          }
          vehicle {
            licensePlate
            imei
            vehicleType {
              type
              category
              icon
            }
            device {
              identifier
              phoneNo
              deviceName
            }
          }
        }
        pagination {
          total
          page
          show
          startCursor
          endCursor
        }
      }
    }
  }
`

export const GET_RAW_ALERT = gql`
  query RawAlert($filter: GetDetailRawAlertFilter!) {
    rawAlert(filter: $filter) {
      isSuccessful
      errorCode
      errorName
      message
      status
      rawAlert {
        createdOn
        vehicleId
        alertFlag
        alertData
        formattedAlertData
        latitude
        longitude
        alertTrigger
        threshold
        driver {
          fullname
          phoneNo
        }
        alert {
          alertCode
          descriptionEng
          descriptionIdn
          iconUrl
          alertCategories {
            alertCategoryId
          }
        }
        vehicle {
          licensePlate
          imei
          vehicleType {
            type
            category
            icon
          }
          device {
            identifier
            phoneNo
            deviceName
            deviceCode
          }
          sensor {
            sensorCode
          }
          children {
            imei
            id
            device {
              deviceCode
            }
          }
        }
        geofence
        locationHistory {
          sentOn
          latitude
          longitude
          speed
        }
        previousAlerts {
          alertCode
          createdOn
          vehicleId
          alert {
            alertCode
            descriptionEng
            descriptionIdn
            fullDescriptionEng
            fullDescriptionIdn
            iconUrl
            enabledInRule
          }
          latitude
          longitude
          isImportant
          isUrgent
        }
        media {
          downloadId
          downloadOn
          endTime
          mediaFilename
          startTime
          channel
          identifier
          url
          status
        }
        alertCode
        address
        driverId
        isFalseAlert
        isUrgent
        isImportant
        isResolved
        rawAlertId
        readOn
        isRead
        childVehicleId
        sourceDeviceCategory
        sourceDeviceType
        userLogs {
          data
          createdOn
          userId
          user {
            fullname
          }
          typeField
        }
        lastUserFeedback {
          feedback
          createdOn
          userId
          user {
            fullname
          }
        }
      }
    }
  }
`

export const SET_ENGINE_STATUS = gql`
  mutation SetEngineStatus($input: SetEngineStatusInput) {
    setEngineStatus(input: $input) {
      isSuccessful
      message
      setEngineStatus {
        currentEngineStatus
        commandStatus
      }
    }
  }
`

export const REGISTER_CALL_NUMBER = gql`
  mutation RegisterCallNumber($input: RegisterCallNumberInput!) {
    registerCallNumber(input: $input) {
      isSuccessful
      message
      registerCallNumber {
        imei
        phoneNumber
      }
    }
  }
`

export const GET_OVER_SPEED_DURATIONS = gql`
  query OverspeedDurations($filter: OverspeedDurationFilter) {
    overspeedDurations(filter: $filter) {
      isSuccessful
      message
      overspeedDurations {
        pagination {
          endCursor
          page
          show
          startCursor
          total
        }
        data {
          totalData
          totalDistance
          totalDuration
          overspeedDatas {
            distance
            driver {
              fullname
            }
            duration
            endDate
            maxSpeed
            speedLimit
            startDate
            vehicleId
            startLocation
            endLocation
          }
        }
      }
    }
  }
`

export const GET_VEHICLE_STATUS_BY_ID = gql`
  query Vehicle($filter: GetVehicleStatusInput!) {
    vehicleStatus(filter: $filter) {
      vehicleStatus {
        vehicle {
          id
          imei
          licensePlate
          odometer
          vehicleType {
            category
            model
            type
            manufacturer
            icon
          }
        }
        lastPacket
        lastPositionStatus
      }
    }
  }
`

export const GET_VEHICLE_STATUSES_LAST_RECEIVE = gql`
  query VehicleStatuses($filter: GetVehicleStatusesInput) {
    vehicleStatuses(filter: $filter) {
      vehicleStatuses {
        lastReceive
        engineOn
        vehicleId
      }
    }
  }
`

export const GET_VEHICLE_STATUSES_LIVEVIEW = gql`
  query VehicleStatusesLiveview($filter: VehicleStatusesLiveviewFilter) {
    vehicleStatusesLiveview(filter: $filter) {
      isSuccessful
      errorCode
      errorName
      message
      status
      vehicleStatusesLiveview {
        vehicle {
          hullNo
          licensePlate
          vehicleType {
            icon
          }
        }
        latitude
        longitude
        direction
        vehicleId
      }
    }
  }
`

export const GET_DETAIL_TRIP_HISTORIES = gql`
  query DetailTripHistories($filter: GetDetailTripHistoryFilter!) {
    detailTripHistories(filter: $filter) {
      isSuccessful
      errorCode
      errorName
      message
      status
      detailTripHistories {
        data {
          latitude
          longitude
          direction
          sentOn
          speed
        }
        stoppage {
          startDate
          endDate
          stopLat
          stopLong
        }
      }
    }
  }
`
